/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SettingsBatteryQueryResponse } from '../../types/GetV1SettingsBattery.ts'

export const getV1SettingsBatteryQueryKey = () => [{ url: '/v1/settings/battery' }] as const

export type GetV1SettingsBatteryQueryKey = ReturnType<typeof getV1SettingsBatteryQueryKey>

/**
 * {@link /v1/settings/battery}
 */
export async function getV1SettingsBattery(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SettingsBatteryQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/settings/battery`, ...requestConfig })
    return res
}

export function getV1SettingsBatteryQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SettingsBatteryQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SettingsBatteryQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SettingsBatteryQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1SettingsBattery(config)
        },
    })
}

/**
 * {@link /v1/settings/battery}
 */
export function useGetV1SettingsBattery<
    TData = ResponseConfig<GetV1SettingsBatteryQueryResponse>,
    TQueryData = ResponseConfig<GetV1SettingsBatteryQueryResponse>,
    TQueryKey extends QueryKey = GetV1SettingsBatteryQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SettingsBatteryQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SettingsBatteryQueryKey()

    const query = useQuery(
        {
            ...getV1SettingsBatteryQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
